module.exports = __webpack_public_path__ + "img/handler.394a136b.svg";